<script lang="ts" setup>
import { BreadcrumbsProps } from "~/components/Utils/Breadcrumbs.props"
import { ListPostsProps } from "~/components/Grid/ListPosts.props"
import { customPaths } from "~/utils/constants"
import { SeoBaseProps } from "~/components/seo/Base.props"

const { locale } = useI18n()
const route = useRoute()

const posts: ListPostsProps = reactive({
  title: "",
  postsList: [],
  totalPosts: 0
})

const { data: pageData, error: pageError } = await usePage(
  `/api/gluon/fetchTopMagazineCategoryPage/${locale.value}/${
    route.params.category as string
  }/top_magazine_category.js`,
  {
    method: "GET"
  }
)

// As per TF-2146, whenever we have a "not found page" error we gotta throw the "404" UI (instead of the "500" one, which would get executed by default by the above "fetchTopMagazineCategoryPage" call)
if (pageError.value?.statusCode === 404) throw createError({ statusCode: 404 })

const { data: getCategoryPosts, error: errorGetCategoryPosts } = await useFetch(
  `/api/magazine/getPostsCategoryPagination/0/12/${pageData.value?.category?.slug}`,
  {
    method: "GET"
  }
)

if (errorGetCategoryPosts.value) {
  console.warn("error get category of Magazine", errorGetCategoryPosts.value)
} else {
  posts.title = getCategoryPosts?.value?.title ?? ""
  posts.postsList = getCategoryPosts?.value?.posts ?? []
  posts.totalPosts = getCategoryPosts?.value?.total ?? 0
}

const breadcrumbs: ComputedRef<BreadcrumbsProps> = computed(() => ({
  links: [
    {
      label: "Home",
      to: "/"
    },
    {
      label: "Top Magazine",
      to: customPaths.magazineRoot
    }
  ],
  currentPage: posts?.title
}))
</script>

<template>
  <div class="all-posts-of-category">
    <SeoBase v-bind="pageData!.seo" />
    <PagesPosts
      :breadcrumbsLinks="breadcrumbs"
      :postsList="posts"
      :hasDropdownCategory="false"
    />
  </div>
</template>
